import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Query} from 'react-apollo'
import {GET_PERSON} from '../../People/mutations'
import BlockWithLoader from '../../Support/BlockWithLoader'
import Form from '../../People/Form'

class PersonTab extends Component {
  render() {
    return (
      <Query query={GET_PERSON} variables={{id: this.props.personId}}>
        {({data, loading, error}) => {
          if (error) return <div>An unexpected error occurred</div>

          return (
            <BlockWithLoader loading={loading} renderChildren={true}>
              {!loading && <Form
                editData={data.person}
                afterSubmit={()=>{}}
                permissionGroupsData={data.groups}
                companiesData={data.companies.list}
              />}
            </BlockWithLoader>
          )
        }}
      </Query>
    )
  }
}

PersonTab.propTypes = {
  personId: PropTypes.number.isRequired
}

export default PersonTab



// WEBPACK FOOTER //
// ./src/components/Profile/tabs/PersonTab.js